module.exports = __webpack_public_path__ + "static/media/cart_white.13a30594.svg";